import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

// Oct 2026 footer-CLS fix — field data (/admin/health → Real-user CLS)
// showed `footer[data-testid=site-footer]` as THE top shifting element
// (2,370 shifts / 7d, desktop p75 0.38). Cause: prerendered HTML paints
// the full page, then React's createRoot wipes it and mounts the lazy
// route's Suspense fallback (60vh) until the chunk arrives → footer
// jumps up, then back down. We measure the prerendered <main> BEFORE
// render so the fallback can reserve exactly that height.
try {
  const prerenderedMain = document.querySelector("#root main");
  window.__tbbPrerenderMainHeight = prerenderedMain ? prerenderedMain.offsetHeight : 0;
} catch { window.__tbbPrerenderMainHeight = 0; }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <App />
            <Toaster position="top-right" richColors closeButton />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </HelmetProvider>
);
